<template>
  <div class="navbar-wrapper" id="tsection">
    <transition name="fade">
    <div class="active-nav" v-if="toggle">
      <div class="link shorthand">
        <div v-for="navItem in navMain" class="small-div">
          <a class="div-link" :href="[navItem.section ? '/?anchor=' + navItem.section : navItem.path]" @click="[ navItem.section ? onScrollTo($event, 'landing', navItem.section) : (navItem.path ? '' : navItem.subnav ? onPressSubnav($event, navItem) : $event.preventDefault())]"  :class="{ active : $route.name === navItem.name }">
            <span class="link" style="display:inline-block;">
              {{ navItem.title }}
            </span>
            <span v-if="navItem.subnav" style="display:inline-block;">
              &nbsp;
              <i v-if="navItem.subnavOpen" class="fa fa-caret-down" style="vertical-align:middle;font-size:1.2em;"></i>
              <i v-if="!navItem.subnavOpen" class="fa fa-caret-right" style="vertical-align:middle;font-size:1.2em;"></i>
            </span>
          </a>
          <div v-if="navItem.subnav && navItem.subnavOpen === true"
            v-for="(navSubItem, subindex) in navItem.subnav" class="small-div-sub">
            <a class="div-link" :href="[navSubItem.section ? '/?anchor=' + navSubItem.section : navSubItem.path]" @click="[ navSubItem.section ? onScrollTo($event, 'landing', navSubItem.section) : (navSubItem.path ? '' : $event.preventDefault())]"  :class="{ active : $route.name === navSubItem.name }">
              <span class="link" style="font-size:0.9em;">
                {{ navSubItem.title }}
              </span>
            </a><span style="color:white;" v-if="(subindex !== navItem.subnav.length-1) && false">&nbsp;|&nbsp;</span>
          </div>
        </div>
        <div class="small-div">
          <div>
            <a class="elink" :href="['mailto:' + navEmail]">{{ navEmail }}</a>
          </div>
        </div>
        <div class="small-div">
          <div class="eicon">
            <a href="https://www.facebook.com/" target="_blank" v-if="false"><i class="fa fa-facebook" aria-hidden="true"></i></a>
            <a :href="navFacebook.path" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i>&nbsp;&nbsp; / {{ navFacebook.title }}</a>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <div class="full-layer">
      <navbar-full :toggle="toggle" @onToggle="toggle = $event"></navbar-full>
    </div>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import NavbarFull from './NavBarFull.vue'

export default {
  name: 'topsection',
  components: {
    'NavbarFull': NavbarFull
  },
  data () {
    return {
      toggle: false,
      navMain: EventBus._data._navMain,
      navEmail: EventBus._data._navEmail
    }
  },
  computed: {
    navFacebook: () => EventBus.getSocialNav('facebook')
  },
  watch: {
    toggle: function (val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  methods: {
    onlink: function (el) {
      this.toggle = !this.toggle
      var root = document.documentElement
      root.className = ''

      this.$scrollTo(el)
    },

    onScrollTo ($event, name, target) {
      $event.preventDefault()
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.toggle = !this.toggle
        var root = document.documentElement
        root.className = ''

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 })
      }
    },

    onPressSubnav ($event, navItem) {
      $event.preventDefault()
      navItem.subnavOpen = !navItem.subnavOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";

.topsection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topsection {
  min-height: 250px;
  width: 100%;
  height: auto;
  position: relative;
  background: transparent;
  margin-top: 50px;

  @media screen and (min-width: $desktop) {
    margin-top: 0;
  }
  & .ccontainer {
    max-width: 1152px !important;
    z-index: 1;
  }
}

$color-yellow: #FEC624;
$widescreen: 1200px;

#tsection {
  font-size: 0.95em;
  letter-spacing: 0.1em;
  // min-height: 100vh;

  & .active-nav {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.9);
    z-index: 10;
    line-height: 1;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    display: flex;

    & .link a {
      color: $color-black;
      display: block;
      margin-bottom: 0rem;

      @media screen and (min-width: $tablet) {
        margin-bottom: 1rem;
      }

      @media screen and (min-width: $desktop) {
        margin-bottom: 1rem;
      }
      // potrait
      @media (max-width: 420px) and (min-height: 480px) {
        margin-bottom: 1rem;

        // extra mini
        @media (max-width: 320px) {
          margin-bottom: 0rem;
        }
      }
      // landscape mobile
      @media (min-width: 480px) and (max-height: 420px) {
        margin-bottom: 1rem;
      }

      &:before {
        background-color: $color-black;
      }
      &:hover {
        color: $color-orange;
      }
    }
    & .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      height: 100%;

      &.shorthand {
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-flex-direction: row;
        flex-direction: row;
        height: 50%;

        & .small-div {
          width: 100%;
          text-align: center;

          // potrait
          @media (max-width: 420px) and (min-height: 480px) {
            width: 100%;
          }
          // landscape mobile
          @media (min-width: 480px) and (max-height: 420px) {
            width: 50%;
          }

          & div,
          & .div-link {
            display: inline-block;
            text-align: center;
            padding: 0.5rem;
          }
          &:first-child {
            // @media screen and (min-height: 601px) {
            margin-top: 2rem;

            @media screen and (min-width: $tablet) {
              margin-top: 2rem;
            }
            // potrait
            @media (max-width: 420px) and (min-height: 480px) {
              margin-top: 2rem;
            }
            // landscape mobile
            @media (min-width: 480px) and (max-height: 420px) {
              margin-top: 0rem;
            }
          }
          &:nth-child(5) { // TODO: manually adjust this to separate menu items
            margin-top: 2em;
            @media (min-width: 480px) and (max-height: 420px) {
              margin-top: 0rem;
            }
          }
        }
      }
      .small-div-sub {
        // margin-left: 5em;

        &:nth-child(2) {
          margin-top: 1em;
        }
        &:last-child {
          margin-bottom: 1em;
        }
      }
    }
    & .link .elink {
      &:before {
        background-color: $color-red;
      }
      &:hover {
        color: $color-orange;
      }
    }
    & .link .eicon {
      // custom for iphone 4 and 5
      & a {
        display: inline-block;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        &:before {
          height: 0;
        }
      }
      & i {
        font-size: 2rem;
        // width: 50px;
        // height: 50px;
        vertical-align: middle;
      }
    }
  }

  & .logo {
    padding: 0 30px;
    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }
  & .sub {
    padding: 30px 30px;
    @media screen and (min-width: $tablet) {
      padding-top: 50px;
      padding-left: 60px;
      padding-right: 60px;
    }
    @media screen and (min-width: $desktop) {
      padding-top: 50px;
      padding-left: 30px;
      padding-right: 30px;
    }
    @media screen and (min-width: $widescreen) {
      padding-top: 70px;
    }
  }
}

.full-layer {
  // min-height: 100vh;
  /*height: 100px;*/
  display: flex;
  flex-direction: column;

  // html.modal-open & {
  //   // this to remove scrollability
  //   pointer-events: none;
  // }
}
@media screen and (min-width: 1008px) {
  .topsection {
    min-height: calc(100vh - 135px);
  }
}
</style>



// WEBPACK FOOTER //
// NavBarOverlay.vue?2a1300bc